import { Constructor } from '@angular/cdk/table';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { compareArrays } from '../utils/array-utils';
import { ISponsoredAuthor } from 'src/app/core/dtos/interfaces/i-sponsored-author-dto';

type WithSponsoredAuthorFormSectionType = {
  _initSponsoredAuthor(sponsoredAuthors: ISponsoredAuthor[]): void;
  _initSponsoredAuthorValueChanges(
    getPreviousSelectedValue: () => ISponsoredAuthor[] | null
  ): void;
  _buildSponsoredAuthor(): ISponsoredAuthor[];
  get sponsoredAuthors(): ISponsoredAuthor[];
};

type SponsoredAuthorFormSectionRequerimentsBase = {
  form: FormGroup;
  FORM_PATHS: { SPONSORED_AUTHORS: () => string };
  destroy$: Subject<boolean>;
};

export function WithSponsoredAuthorFormSection<
  TBase extends Constructor<SponsoredAuthorFormSectionRequerimentsBase>
>(
  baseClass: TBase
): {
  new (...args: any[]): WithSponsoredAuthorFormSectionType;
  prototype: WithSponsoredAuthorFormSectionType;
} & TBase {
  return class WithSponsoredAuthorFormSectionable extends baseClass {
    constructor(...args: any[]) {
      super(...args);
    }

    _initSponsoredAuthor(sponsoredAuthors: ISponsoredAuthor[]): void {
      sponsoredAuthors.forEach((link) => {
        (
          this.form.get(this.FORM_PATHS.SPONSORED_AUTHORS()) as FormArray<
            FormControl<ISponsoredAuthor>
          >
        ).push(new FormControl(link));
      });
      this.form.get(this.FORM_PATHS.SPONSORED_AUTHORS()).markAsPristine();
    }

    _initSponsoredAuthorValueChanges(
      getPreviousSelectedValue: () => ISponsoredAuthor[] | null
    ): void {
      this.form
        .get(this.FORM_PATHS.SPONSORED_AUTHORS())
        .valueChanges.pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (newValue) => {
            if (compareArrays(newValue, getPreviousSelectedValue())) {
              this.form
                .get(this.FORM_PATHS.SPONSORED_AUTHORS())
                .markAsPristine();
            } else {
              this.form.get(this.FORM_PATHS.SPONSORED_AUTHORS()).markAsDirty();
            }
          },
        });
    }

    _buildSponsoredAuthor(): ISponsoredAuthor[] {
      return this.form.get(this.FORM_PATHS.SPONSORED_AUTHORS()).value;
    }

    get sponsoredAuthors(): ISponsoredAuthor[] {
      return this.form.get(this.FORM_PATHS.SPONSORED_AUTHORS()).value;
    }
  };
}
